import { render, staticRenderFns } from "./PageHeaderImage.vue?vue&type=template&id=0c5b3949&"
import script from "./PageHeaderImage.vue?vue&type=script&lang=js&"
export * from "./PageHeaderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports